var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body"},[_c('div',{staticClass:"section wf-section"}),_c('div',{staticClass:"section-2 last wf-section"},[_c('div',{staticClass:"container w-container"},[_c('div',{staticClass:"arbitrarily-placed-and-sized-parent-element"},[_c('div',{staticClass:"video-embed-object-fit-cover"},[_c('div',{attrs:{"id":"dcPlayer"}})])])])])])
}]

export { render, staticRenderFns }